module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container modal-container-result-insurer"
  }, [_c('div', {
    staticClass: "modal-header modal-header-result-insurer"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": (_vm.imagesPath || 'images/login-insurers') + '/' + _vm.insurer.name + '.png',
      "alt": _vm.insurer.name,
      "width": "30"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.insurer.name.toUpperCase()))]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-body-result-insurer"
  }, [_c('h4', [_c('icon', {
    attrs: {
      "name": "money"
    }
  }), _vm._v(" Valores")], 1), _vm._v(" "), _c('b', [_vm._v("Prêmio:")]), _vm._v(" R$ " + _vm._s(_vm.numberBrazilianPattern(_vm.quotationResult.value, 2)) + " "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Franquia:")]), _vm._v(" R$ " + _vm._s(_vm.quotationResult.franchise) + " "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Tempo de cálculo:")]), _vm._v(" " + _vm._s(_vm.quotationResult.time) + " segundos "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_c('icon', {
    attrs: {
      "name": "bar-chart"
    }
  }), _vm._v(" Coberturas")], 1), _vm._v(" "), _vm._l((_vm.quotationResult.coverages), function(value, key) {
    return _c('div', {
      key: key
    }, [_c('b', [_vm._v(_vm._s(_vm.humanizedParameter[key]) + " : ")]), _vm._v(" " + _vm._s(value) + "\n                    ")])
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_c('icon', {
    attrs: {
      "name": "bar-chart"
    }
  }), _vm._v(" Franquias das coberturas")], 1), _vm._v(" "), _vm._l((_vm.quotationResult.franchises), function(value, key) {
    return _c('div', {
      key: key
    }, [_c('b', [_vm._v(_vm._s(_vm.humanizedParameter[key]) + " : ")]), _vm._v(" " + _vm._s(value) + "\n                    ")])
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_c('icon', {
    attrs: {
      "name": "info-circle"
    }
  }), _vm._v(" Residência/Produto/ID")], 1), _vm._v(" "), _c('b', [_vm._v("Residência:")]), _vm._v(" " + _vm._s(_vm.quotationResult.residenceHover || _vm.quotationResult.residence) + " "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Produto:")]), _vm._v(" " + _vm._s(_vm.quotationResult.product) + " "), _c('br'), _vm._v(" "), _c('b', [_vm._v("ID:")]), _vm._v(" "), _c('a', {
    staticClass: "open-residence-quotation",
    attrs: {
      "href": "javascript:void(0)",
      "data-preco-id": _vm.quotationResult.priceId
    }
  }, [_vm._v(_vm._s(_vm.quotationResult.code))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_c('icon', {
    attrs: {
      "name": "money"
    }
  }), _vm._v(" Parcelamento")], 1), _vm._v(" "), _vm._l((_vm.quotationResult.paymentForms), function(payments, paymentType) {
    return _c('div', {
      key: paymentType,
      staticClass: "payments"
    }, [_c('h5', [_c('b', [_vm._v(_vm._s(_vm.paymentTypesPreDefinition[paymentType] || paymentType))])]), _vm._v(" "), _vm._l((payments), function(value, key) {
      return _c('div', {
        key: key
      }, [_vm._v("\n                            " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2)
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_c('icon', {
    attrs: {
      "name": "comments"
    }
  }), _vm._v(" Ajustes")], 1), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.quotationResult.adjustmentsHover || _vm.quotationResult.adjustments || '<em>Nenhuma informação</em>')
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_c('icon', {
    attrs: {
      "name": "comments"
    }
  }), _vm._v(" Mensagens da insurer")], 1), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.quotationResult.messageHover || _vm.quotationResult.message || '<em>Nenhuma informação</em>')
    }
  })], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f02c291","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/enterprise/modules/Result/PartialModalResultInsurerDetails.vue
// module id = 344
// module chunks = 0